'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = template;

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IDate = require('../../../common/iObjects/IDate');

var _IDate2 = _interopRequireDefault(_IDate);

var _Button = require('../../Button');

var _Button2 = _interopRequireDefault(_Button);

var _l10n = require('../../../common/l10n');

var _l10n2 = _interopRequireDefault(_l10n);

var _IconButton = require('../../IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template() {
    var _this = this;

    var nextYear = _react2.default.createElement('span', null),
        prevYear = _react2.default.createElement('span', null),
        classList = this.compileStyle(_index2.default),
        theme = this.props.theme;

    // year change buttons
    if (this.props.yearChange) {
        prevYear = _react2.default.createElement(_IconButton2.default, {
            onClick: function onClick(e) {
                return _this._shift(-1);
            },
            className: classList.controlLeft,
            icon: theme.monthDecreaseIcon
        });
        nextYear = _react2.default.createElement(_IconButton2.default, {
            onClick: function onClick(e) {
                return _this._shift(1);
            },
            className: classList.controlRight,
            icon: theme.monthIncreaseIcon
        });
    }

    // calendar dates
    var month = void 0,
        calendar = [],
        row = void 0,
        i = 0,
        j = 0,
        monthIndex = 0;

    for (i; i < 4; i++) {
        j = 0;
        row = [];

        var _loop = function _loop() {
            month = _this._monthCount[monthIndex];
            monthIndex++;

            var date = new _IDate2.default('01.' + month + '.' + _this._currYear).set({ hours: 0, minutes: 0 }),
                isStartSelected = _this._isStartOfPeriod(date),
                isEndSelected = _this._isEndOfPeriod(date),
                periodOverlay = null,
                monthDOM = null,
                dateStyle = classList.date;

            if (_this._isDateInPeriod(date)) {
                var periodOverlayStyle = classList.period;

                // начало периода или первый месяц ряда
                if (isStartSelected || j === 0) {
                    periodOverlayStyle = classList.periodStart;
                }

                // конец периода или последний месяц ряда
                if (isEndSelected || j === 2) {
                    periodOverlayStyle = classList.periodEnd;
                }

                // исключение для показа маски
                if (
                // начало периода выпало на конец ряда
                isStartSelected && j === 2 ||
                // конец периода выпал на начало ряда
                j === 0 && isEndSelected ||
                // период в 1 день
                _this._isOneDayPeriod()) {
                    periodOverlayStyle = classList.periodNoFill;
                }

                periodOverlay = _react2.default.createElement('div', { className: periodOverlayStyle });
            }

            if (_this._isTodaySelected(date)) {
                dateStyle = classList.dateToday;
            }

            if (periodOverlay) {
                dateStyle = classList.datePassive;
            }

            if (isStartSelected || isEndSelected) {
                dateStyle = classList.dateSelected;
            }

            if (_this._isForbiddenDate(date)) {
                dateStyle = classList.dateDisabled;
            }

            // дата календаря
            monthDOM = _react2.default.createElement(
                'div',
                { className: dateStyle, onClick: function onClick(e) {
                        return _this.select(date);
                    } },
                date.toString('fs')
            );

            // календарь
            row.push(_react2.default.createElement(
                'td',
                { className: classList.dateWrapper, key: 'month-' + monthIndex },
                periodOverlay,
                monthDOM
            ));
        };

        for (j; j < 3; j++) {
            _loop();
        }

        calendar.push(_react2.default.createElement(
            'tr',
            { key: 'row-' + i },
            row
        ));
    }

    var controls = null;

    if (this.props.isPeriod) {
        controls = _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
                'td',
                { colSpan: '7', className: classList.calendarFooter },
                _react2.default.createElement(
                    _Button2.default,
                    {
                        flatPrimary: true,
                        className: classList.calendarBtnCancel,
                        onClick: this.cancel
                    },
                    _l10n2.default.translate('MONTHPICKER_CANCEL')
                ),
                _react2.default.createElement(
                    _Button2.default,
                    {
                        primary: true,
                        onClick: this.submit
                    },
                    _l10n2.default.translate('MONTHPICKER_OK')
                )
            )
        );
    }

    return _react2.default.createElement(
        'div',
        { className: classList.root + ' ' + (this.props.classList || '') },
        _react2.default.createElement(
            'div',
            { className: classList.calendar },
            _react2.default.createElement(
                'div',
                { className: classList.calendarHead },
                _react2.default.createElement(
                    'table',
                    null,
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { colSpan: '7', className: classList.control },
                                prevYear,
                                _react2.default.createElement(
                                    'span',
                                    { className: classList.controlYear },
                                    this._currYear
                                ),
                                nextYear
                            )
                        )
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                { className: classList.calendarBody },
                _react2.default.createElement(
                    'table',
                    { className: classList.calendar },
                    _react2.default.createElement(
                        'tbody',
                        null,
                        calendar
                    ),
                    _react2.default.createElement(
                        'tfoot',
                        null,
                        controls
                    )
                )
            )
        )
    );
}